export default __webpack_public_path__ + "static/media/shape5.d4b36581.svg";